module.exports = __webpack_public_path__ + "img/Bloque_Agendar.4bb4d29.svg";